import styled from 'styled-components';

export const Page = styled.div``;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0;
  padding: 0 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  @media (max-width: 900px){ grid-template-columns: 1fr; }
`;

export const HeaderCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px;
  padding: 18px;
  h1 { margin: 0 0 6px; color: ${({ theme }) => theme.colors.green[700]}; }
  p { margin: 0; }
`;

export const HeaderImage = styled.div`
  border-radius: 12px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.gray[100]};
  min-height: 220px;
  img{ width:100%; height:100%; object-fit: cover; }
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0;
  padding: 0 16px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  @media (max-width: 900px){
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 600px){
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px;
  overflow: hidden;
  display: flex; flex-direction: column;
  cursor: pointer;
`;

export const Thumb = styled.div`
  height: 160px;
  background: ${({ theme }) => theme.colors.gray[100]};
  img{ width:100%; height:100%; object-fit: cover; }
`;

export const Body = styled.div`
  padding: 14px;
  h3{ margin: 0 0 6px; color: ${({ theme }) => theme.colors.green[700]}; }
  p{ margin: 0; color: ${({ theme }) => theme.colors.text}; }
`;

export const Pager = styled.div`
  display: flex; gap: 10px; justify-content: center; align-items: center; margin-top: 12px;
  button{ padding: 8px 12px; border-radius: 8px; border: 1px solid ${({ theme }) => theme.colors.gray[300]}; background: white; cursor: pointer; }
`;
